import { ReportConfig } from "../definitions";

const deliveryCompanyReport: ReportConfig = {
  id: "deliveryCompanyReport",
  name: "Companies With Outstanding Delivery Requirements",
  options: [
    {
      name: "company",
      label: "Company",
      dataType: "select-dynamic",
      // defaultValue: 59,
      optionsDataSource: {
        sql: `
      SELECT '' AS ID, '-- Select a Company --' AS [Name]
      UNION ALL
      SELECT ID, [Name]
      FROM dbo.Company
      WHERE IsDeleted = 0
      ORDER BY [Name]`,
        returnType: "options",
      },
    },
  ],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "",
          widgetType: "table",
          columns: [
            { name: "Agent", type: "string" },
            { name: "Phone", type: "string" },
            { name: "Applicant", type: "string" },
            { name: "Entry date", type: "date" },
            { name: "Carrier", type: "string" },
            { name: "Policy Number", type: "string" },
            { name: "Premium", type: "currency", align: "right" },
            { name: "Status", type: "string" },
            { name: "Delivery date", type: "date" },
            { name: "Outstanding UW Requirements", type: "number", summary: "count" },
            { name: "Annualized Premium", type: "currency", align: "right" },
          ],
          dataSource: {
            sql: `
-- declare @company int = 131;
-- declare @company int = 59;

if @company=''
BEGIN
  SELECT 'You must select a company' as [Notice]
  RETURN
END
ELSE

SELECT
    (b.[FirstName] + ' ' + b.[LastName]) AS [AgentName],
    bp.PhoneNumber,
    (a.[FirstName] + ' ' + a.[LastName]) AS [Applicant],
    a.EntryDate,
    cr.[Type],
    [a].[PolicyNumber],
    ap.[AnnualPremium],
    [rs].[StatusName],
    a.[DeliveryDueDate],
    [r].[RequirementDescription],
    -- [rc].[Description] AS RequirementCodeDescription,
    -- [rt].[TypeDescription],
    ap.[AnnualizedPremium] * aa.[CommissionPercent]

FROM [awu].[Application] AS [a]
    INNER JOIN [dbo].CarrierType cr on a.CarrierID = cr.ID
    INNER JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
    INNER JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID AND aa.[CommissionLevel] = 1
    INNER JOIN dbo.Broker b on aa.Brokerid = b.ID
    INNER JOIN dbo.BrokerPhone bp on aa.Brokerid = bp.BrokerID AND bp.IsPrimary = 1
    LEFT JOIN [awu].[Requirements] AS [r] ON [a].[ID] = [r].[ApplicationID]
    LEFT JOIN [awu].[RequirementStatus] AS [rs] ON [r].[RequirementStatusID] = [rs].[ID]
    LEFT JOIN [awu].[RequirementType] AS [rt] ON [r].[RequirementTypeCode] = [rt].[Code]
    LEFT JOIN [awu].[RequirementCode] AS [rc] ON [r].[RequirementCodeCode] = [rc].[Code]

WHERE ([a].[IsDeleted] IS NULL OR [a].[IsDeleted] = 0)
    AND [rs].[StatusName] = 'Outstanding'
    AND st.[ApplicationStatusCode] IN ('S')
    AND st.[ScenarioTypeCode] = 'F'
    AND b.CompanyID = @company
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)

ORDER BY EntryDate, PolicyNumber

            `,
            returnType: "table",
          },
          options: { summary: false, summaryInData: false, zebraFieldIndex: [5] },
        },
      ],
    },
  ],
};

export default deliveryCompanyReport;
